import { render, staticRenderFns } from "./BotonPedir.vue?vue&type=template&id=723b5147&scoped=true"
import script from "./BotonPedir.vue?vue&type=script&lang=js"
export * from "./BotonPedir.vue?vue&type=script&lang=js"
import style0 from "./BotonPedir.vue?vue&type=style&index=0&id=723b5147&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "723b5147",
  null
  
)

export default component.exports